import React from "react";
import { ArrowRight, Linkedin, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const teamMembers = [{
  name: "Marcus Vance",
  role: "Director of Campaigns",
  specialty: "Branded Campaign Architect",
  bio: "Architects high-converting branded funnels specifically for the solar and roofing sectors.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586938/img/team_marcus_vance.png"
}, {
  name: "Sarah Jenkins",
  role: "Lead Generation Specialist",
  specialty: "Aged Lead Strategist",
  bio: "Expert in reactivating and monetizing aged lead databases with precision targeting.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586938/img/team_sarah_jenkins.png"
}, {
  name: "David Chen",
  role: "Head of Analytics",
  specialty: "Data & ROI Optimizer",
  bio: "Transforms raw campaign data into actionable insights to maximize client return on investment.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586938/img/team_david_chen.png"
}, {
  name: "Elena Rostova",
  role: "Client Success Manager",
  specialty: "Home Improvement Liaison",
  bio: "Ensures seamless delivery and scaling of lead volume for kitchen and bath remodeling partners.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586938/img/team_elena_rostova.png"
}];
export default function MeetTheStrategists() {
  return;
}